// src/components/data-sources/components/IndeterminateCheckbox.tsx

import React, { useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';

interface IndeterminateCheckboxProps {
    checked: boolean;
    indeterminate: boolean;
    onChange: () => void;
    disabled?: boolean;
    className?: string;
}

export const IndeterminateCheckbox: React.FC<IndeterminateCheckboxProps> = ({
                                                                                checked,
                                                                                indeterminate,
                                                                                onChange,
                                                                                disabled = false,
                                                                                className = ''
                                                                            }) => {
    const checkboxRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return (
        <Form.Check
            type="checkbox"
            ref={checkboxRef}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={className}
            aria-label="Select all items"
        />
    );
};

export default IndeterminateCheckbox;